/**
 * Reporting Routes
 *
 * Routes for analytics, reporting, fast track, and POA.
 */
import React from 'react';
import { createRoute } from '@tanstack/react-router';
import { createPermissionBeforeLoad } from '@bb/session-manager';
import { authLayoutRoute } from '../rootRoute';
import * as groups from '../../groups.config';

// Lazy load pages
const Analytics = React.lazy(() => import('../../pages/Analytics/Analytics'));
const Reporting = React.lazy(() => import('../../pages/Reporting/Reporting'));
const FastTrack = React.lazy(() => import('../../pages/FastTrack/FastTrack'));
const POA = React.lazy(() => import('../../pages/POA/POA'));
const ViewPoA = React.lazy(() => import('../../pages/ViewPoA'));

// Permission checks
const analyticsPermission = createPermissionBeforeLoad({
  permissions: [groups.METRICS_DASHBOARD_PERMISSION, groups.METRICS_FASTTRACK_PERMISSION],
  forbiddenPath: '/bbweb/home',
});

const reportingPermission = createPermissionBeforeLoad({
  permissions: [groups.REPORTING_DASHBOARD_PERMISSION],
  forbiddenPath: '/bbweb/home',
});

const fastTrackPermission = createPermissionBeforeLoad({
  permissions: [groups.FAST_TRACK_PERMISSION],
  forbiddenPath: '/bbweb/home',
});

const poaPermission = createPermissionBeforeLoad({
  permissions: [groups.POA_INTAKE_PERMISSION, groups.POA_REVIEW_PERMISSION, groups.POA_GEMS_PERMISSION],
  forbiddenPath: '/bbweb/home',
});

const poaReviewPermission = createPermissionBeforeLoad({
  permissions: [groups.POA_REVIEW_PERMISSION],
  forbiddenPath: '/bbweb/home',
});

// ============================================
// ANALYTICS
// ============================================
export const analyticsRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/analytics',
  beforeLoad: analyticsPermission,
  component: Analytics,
});

// ============================================
// REPORTING
// ============================================
export const reportingRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/reporting',
  beforeLoad: reportingPermission,
  component: Reporting,
});

// ============================================
// FAST TRACK
// ============================================
export const fastTrackRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/ft',
  beforeLoad: fastTrackPermission,
  component: FastTrack,
});

// ============================================
// POA
// ============================================
export const poaRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/poa',
  beforeLoad: poaPermission,
  component: POA,
});

export const poaDetailRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/poa/$reqId',
  beforeLoad: poaReviewPermission,
  component: ViewPoA,
});

export const reportingRoutes = [
  analyticsRoute,
  reportingRoute,
  fastTrackRoute,
  poaRoute,
  poaDetailRoute,
];
